import {
  REASON,
} from './fields';

export default function payload() {
  return {
    reason: {
      field: REASON,
    },
  };
}
